import { defineStore } from 'pinia';
import { fetchPortalSummary } from '@/api/portal';
import { ApiError, type AsyncState } from '@/core';
import type { PortalSummary } from '@/api/schemas/portal';

/**
 * C4 — store do resumo do portal (Início e badges do shell).
 *
 * Multi-clínica: o resumo é por unidade — ao trocar a clínica ativa, o consumidor chama
 * `load(companyId)` e o estado da unidade anterior é descartado (nunca misturado).
 */
interface PortalStoreState {
  summary: AsyncState<PortalSummary>;
}

export const usePortalStore = defineStore('portal', {
  state: (): PortalStoreState => ({ summary: { kind: 'idle' } }),
  actions: {
    async load(companyId: string): Promise<void> {
      this.summary = { kind: 'loading' };
      try {
        const value = await fetchPortalSummary(companyId);
        this.summary = { kind: 'data', value };
      } catch (cause) {
        const error = cause instanceof ApiError
          ? cause
          : new ApiError({
              status: 0,
              correlationId: undefined,
              kind: 'network',
              message: 'Não foi possível carregar o resumo. Tente novamente.',
            });
        this.summary = { kind: 'error', error };
      }
    },
    /** Chamado ao trocar de clínica: zera sem nova consulta, para a unidade antiga não vazar. */
    reset(): void {
      this.summary = { kind: 'idle' };
    },
  },
});
